
function Analytics({ analytics }) {
    return (<>

        <div class="card mb-1 mt-1">
            <div class="card-body">
                <div class="mb-3 fw-semibold d-flex align-items-center">
                    <div class="flex-fill">방문자 수</div>
                    {/* <div>
                        <a href="#" data-bs-toggle="dropdown" class="text-body"><i class="bi bi-three-dots-vertical"></i></a>
                        <div class="dropdown-menu dropdown-menu-end" data-bs-theme="light">
                            <a href="#" class="dropdown-item">View full report</a>
                            <a href="#" class="dropdown-item">Reload</a>
                            <a href="#" class="dropdown-item">Export Data</a>
                        </div>
                    </div> */}
                </div>
                <div class="row mb-1">
                    <div class="col-lg-12 position-relative">
                        <h3 class="mb-0 d-flex">
                        {analytics[2]}
                        {analytics[0] > 0 && <div class="fs-13px mt-2"><span class="badge text-bg-success py-5px me-1">+{analytics[0]}</span></div>}
                        </h3>
                        {/* <div class="fs-13px mt-2"><span class="badge bg-theme-subtle text-theme py-5px me-1">+12%</span> compare to last week</div> */}
                        <i class="bi bi-people display-6 lh-1 mt-n2 text-body text-opacity-20 me-3 position-absolute end-0 top-0"></i>
                    </div>
                </div>
                
            </div>

        </div>
        <div class="card mb-1">

            <div class="card-body">
                <div class="mb-3 fw-semibold d-flex align-items-center">
                    <div class="flex-fill">전체 요약 수</div>
                    {/* <div>
                        <a href="#" data-bs-toggle="dropdown" class="text-body"><i class="bi bi-three-dots-vertical"></i></a>
                        <div class="dropdown-menu dropdown-menu-end" data-bs-theme="light">
                            <a href="#" class="dropdown-item">View full report</a>
                            <a href="#" class="dropdown-item">Reload</a>
                            <a href="#" class="dropdown-item">Export Data</a>
                        </div>
                    </div> */}
                </div>
                <div class="row mb-1">
                    <div class="col-lg-12 position-relative">
                        <h3 class="mb-0 d-flex">
                            +{analytics[1]}
                            {/* <div class="fs-13px mt-2"><span class="badge text-bg-success py-5px me-1">+10</span></div> */}

                        </h3>
                        {/* <div class="fs-13px mt-2"><span class="badge bg-theme-subtle text-theme py-5px me-1">+12%</span> compare to last week</div> */}
                        <i class="bi bi-clipboard-data display-6 lh-1 mt-n2 text-body text-opacity-20 me-3 position-absolute end-0 top-0"></i>
                    </div>
                </div>
                {/* <div class="mt-3 fs-11px">
                    <div class="text-body text-opacity-50">last updated on</div>
                    <div class="fw-600 text-body text-opacity-75">Feb 3, 4:09:57 AM UTC</div>
                </div> */}
            </div>

        </div>

        {/* <div class="card" style={{marginTop:10}}>

            <div class="card-body" >

                <div class="d-flex align-items-center mb-3">
                    <div class="flex-fill fw-semibold d-flex align-items-center bold"><strong><i class="bi-clipboard-check text-body text-opacity-25 my-n1 fs-4 me-2"></i> 애널리틱스</strong></div>
                </div>

                <div class="d-flex align-items-center mb-3">
                    <div class="flex-1 ">오늘 방문자 수</div>
                    <small className={`fw-semibold h5 ${analytics[0] > 0 ? 'text-success' : 'text-body'}`}>
                            
                            {analytics[2]}
                            ( {analytics[0] > 0 && <i className="fa fa-caret-up me-1"></i>}{analytics[0]} )
                        </small>
                </div>
                <hr class="border-black" />
                <div class="d-flex align-items-center mb-3">
                    <div class="flex-1">전체 요약 수</div>
                    <small class="fw-semibold text-success h5">+{analytics[1]}</small>
                </div>
            </div>

        </div> */}
    </>);
}

export default Analytics;